import { Component, Input } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ErrorDialogContentComponent } from "./error-dialog-content.component";

@Component({
  selector: "error-dialog",
  template: "",
})
export class ErrorDialogComponent {
  static contentComponent = ErrorDialogContentComponent;

  @Input() options: MatDialogConfig = { autoFocus: true };

  private _messages: any;
  @Input() set messages(value: any) {
    this._messages = value;
    if (this.dialogRef) {
      this.dialogRef.componentInstance["messages"] = value;
    }
  }
  get messages(): any {
    return this._messages;
  }

  dialogRef: any;

  constructor(private dialog: MatDialog) {}

  open() {
    const dialogRef = this.dialog.open(
      ErrorDialogContentComponent,
      this.options,
    );
    const instance = dialogRef.componentInstance;
    instance["messages"] = this._messages;
    this.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  close() {
    if (this.dialogRef) this.dialogRef.close();
  }
}
